module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921111151_T.78be1e91.jpg";